import { storage } from '../storage';
import type { LeaderboardEntry, LeaderboardService } from './leaderboardService';

const KEY = 'pa.leaderboard';
const MAX_STORED = 25;

/** localStorage-backed high-score board. */
export class LocalLeaderboardService implements LeaderboardService {
  private readonly enabled: boolean;

  constructor(enabled: boolean) {
    this.enabled = enabled;
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  private load(): LeaderboardEntry[] {
    return storage.getJSON<LeaderboardEntry[]>(KEY, []);
  }

  async submit(name: string, score: number): Promise<void> {
    if (!this.enabled) return;
    const entries = this.load();
    entries.push({ name: name || 'Player', score });
    entries.sort((a, b) => b.score - a.score);
    storage.setJSON(KEY, entries.slice(0, MAX_STORED));
  }

  async top(n: number): Promise<LeaderboardEntry[]> {
    return this.load().slice(0, n);
  }

  best(): number {
    const entries = this.load();
    return entries.length ? entries[0].score : 0;
  }
}
